export const convertObjToBase64 = param => {
  let queryJSON = JSON.stringify( param )
  return Buffer.from( queryJSON ).toString( 'base64' )
}
